export default __webpack_public_path__ + "static/media/gasflessen_verkoop.9630a2db.svg";